import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AutosBusquedaStoreService } from '../services/store/autos-busqueda-store.service';

export const simulacionAutosGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const autosStore = inject(AutosBusquedaStoreService);

  const url = new URL(state.url, window.location.origin);
  const idPropuesta = url.searchParams.get('idPropuesta');

  // ✅ Dejar pasar si hay versión seleccionada o si viene idPropuesta
  if (autosStore.existeVersionSeleccionada() || idPropuesta) {
    return true;
  }

  // ❌ Si no hay ninguna de las dos cosas, redirigir al home
  router.navigate(['']);
  return false;
};
